import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import React, { useEffect, useState } from "react"
import {
  gaJSON,
  trackFirebaseAnalytics
} from "../../../../shared_component/utils/googleAnalyticsHelpers"
import store from "../../../../shared_component/utils/configureStore"
import {
  searchVehicleByPlate,
  searchVehicleByVin,
  UNKNOWN_VEHICLE_ERROR
} from "../../../../v1/actions/vehicles"
import {
  Button,
  Card,
  Dropdown,
  Form,
  FormField,
  Header,
  Icon,
  Image,
  List,
  ListItem,
  Message,
  Tab,
  TabPane
} from "semantic-ui-react"
import InfoIcon from "../../../../images/info-Icon.svg"
import { states } from "../../../constants"
import { isCanada } from "../../../../v1/helpers/translationHelpers"
import VinInfo from "../../../../images/vin_info.svg"
import CanadianFlag from "../../../../images/canadian_flag.svg"
import questionCircle from "../../../../images/question-circle.svg"
import VehicleInfo from "./VehicleInfo"
import { routerPaths } from "../../../../v1/constants/paths"
import { isEbay } from "../../../../v1/helpers/affiliationHelpers"
import AddVehicleManual from "./AddVehicleManual"
import { reactRouterV3Instrumentation } from "@sentry/react"

const NewVehicle = ({
  t,
  user,
  asModal,
  closeModalHandler,
  serviceRequest,
  history,
  setConfirmScreen = () => {}
}) => {
  const [selectedState, setSelectedState] = useState("")
  const [licensePlate, setLicensePlate] = useState("")
  const [vin, setVin] = useState("")
  const [mile, setMile] = useState("")
  const [mileError, setMileError] = useState("")
  const [licenseError, setLicenseError] = useState("")
  const [vinError, setVinError] = useState("")
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [showVehicle, setShowVehicle] = useState(false)
  const [selectVehicle, setSelectVehicle] = useState(false)
  const [activeIndex, setActiveIndex] = useState(0)
  const vehicles = user.vehicles || []
  const [showAddManualVehicle, setShowAddManualVehicle] = useState(false)

  useEffect(() => {
    setSelectVehicle(vehicles.length > 0)
  }, [])

  const handleStateChange = (e, { value }) => {
    setSelectedState(value)
  }

  const handleTabChange = (e, { activeIndex }) => {
    setActiveIndex(activeIndex)
    trackFirebaseAnalytics({
      event: activeIndex ? gaJSON.EtoB_select_license_plate_tab : gaJSON.EtoB_select_vin_tab
    })
  }
  const handleSearchAgain = () => {
    setShowVehicle(false)
    setSelectVehicle(false)
    setConfirmScreen(false)
    setShowAddManualVehicle(false)
  }

  const handleLicensePlateChange = (e) => {
    setLicensePlate(e.target.value.toUpperCase())
    if (e.target.value.length > 4) {
      setLicenseError("")
    } else {
      setLicenseError(t("licenseValidationError"))
    }
  }

  const handleMileageChange = (e) => {
    const value = e.target.value
    setMile(value)

    const mile = value.toString()
    if (mile.length >= 1 && mile.length <= 7) {
      setMileError("")
    } else {
      setMileError(t("mileValidationError"))
    }
  }

  const handleVinChange = (e) => {
    setVin(e.target.value.toUpperCase())
    if (e.target.value.length == 17) {
      setVinError("")
    } else {
      setVinError(t("vinValidationError"))
    }
  }

  const handleLicenseSubmit = async () => {
    setIsSubmitting(true)
    const success = await store.dispatch(searchVehicleByPlate(licensePlate, selectedState, mile))
    if (typeof success === "boolean") {
      if (serviceRequest) {
        history.push(routerPaths.confirmVehicle)
      } else {
        setShowVehicle(true)
        setConfirmScreen(true)
      }
      setIsSubmitting(false)
    } else {
      if (success && success[0].includes("registered")) {
        setLicenseError(t("licenseExistError"))
      } else {
        setLicenseError(t("licenseError"))
      }
      setIsSubmitting(false)
      trackFirebaseAnalytics({
        event: gaJSON.EtoB_license_submit_error
      })
    }
  }

  const handleVinSubmit = async () => {
    setIsSubmitting(true)
    const success = await store.dispatch(searchVehicleByVin(vin, false, mile))

    if (typeof success === "boolean") {
      if (serviceRequest) {
        history.push(routerPaths.confirmVehicle)
      } else {
        setShowVehicle(true)
        setConfirmScreen(true)
      }
      setIsSubmitting(false)
    } else {
      if (success === UNKNOWN_VEHICLE_ERROR) {
        if (asModal) {
          setShowAddManualVehicle(true)
        } else {
          history.push(routerPaths.addVehicleManual)
        }
        setIsSubmitting(false)
        return
      }
      if (success && success[0].includes("registered")) {
        setVinError(t("vinError"))
      } else {
        setVinError(t("invalidVinError"))
      }
      setIsSubmitting(false)
      trackFirebaseAnalytics({
        event: gaJSON.EtoB_vin_submit_error
      })
    }
  }

  useEffect(() => {
    if (typeof window !== "undefined") {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      window.scrollTo(0, 0)
    }
  }, [showVehicle])

  const panes = [
    {
      menuItem: t("licencePlateTitle"),
      render: () => (
        <TabPane attached={false} className="tab-pane">
          <div>
            <Card fluid className="add-vehicle-info">
              <Image src={InfoIcon} />
              {isEbay() ? t("ebayFindMyVehicleNotes") : t("findMyVehicleInfo")}
            </Card>

            <Form>
              <FormField error={licenseError.length > 0}>
                <label>{t("plateNumberLbl")}</label>
                <input
                  icon={{ name: "search", circular: true, link: true }}
                  maxLength={8}
                  placeholder={t("plateNumberPlaceholder")}
                  value={licensePlate}
                  onChange={handleLicensePlateChange}
                />
                {licenseError && (
                  <Message size="mini" negative>
                    {licenseError}
                  </Message>
                )}
              </FormField>
              <FormField>
                <label>{t("licenseState")}</label>
                <Dropdown
                  placeholder={t("selectState")}
                  fluid
                  search
                  selection
                  options={states}
                  value={selectedState}
                  onChange={handleStateChange}
                />
              </FormField>
              <FormField error={mileError.length > 0}>
                <label>{t("currentVehicleMileage")}</label>
                <input
                  type="number"
                  placeholder={t("mileagePlaceholder")}
                  value={mile}
                  onChange={handleMileageChange}
                />
                {mileError && (
                  <Message size="mini" negative>
                    {mileError}
                  </Message>
                )}
              </FormField>
            </Form>
          </div>
          <div className="action-button">
            <Button
              fluid
              onClick={handleLicenseSubmit}
              loading={isSubmitting}
              disabled={
                !(licensePlate.length > 4 && selectedState.length && mile.length && !mileError) ||
                isSubmitting
              }
              className="primary-button"
            >
              {isEbay() ? t("findMyVehicle") : t("addMyVehicle")}
            </Button>
            {isEbay() && (
              <Card fluid className="add-vehicle-info-noback">
                <Image src={questionCircle} />
                <p dangerouslySetInnerHTML={{ __html: t("ebayVehicleAddNotes") }} />
              </Card>
            )}
          </div>
        </TabPane>
      )
    },
    {
      menuItem: t("vin"),
      render: () => (
        <TabPane attached={false} className="tab-pane">
          <div>
            <Card fluid className="add-vehicle-info">
              <Image src={InfoIcon} />
              {isCanada(user.country)
                ? t("findMyVehicleByVin")
                : isEbay()
                ? t("ebayFindMyVehicleNotes")
                : t("findMyVehicleInfo")}
            </Card>

            <Form>
              <FormField error={vinError.length > 0}>
                <label>{t("vinLbl")}</label>
                <input
                  placeholder={t("vinPlaceholder")}
                  maxLength={17}
                  value={vin}
                  onChange={handleVinChange}
                />
                {vinError && (
                  <Message size="mini" negative>
                    {vinError}
                  </Message>
                )}
              </FormField>
              <FormField error={mileError.length > 0}>
                <label>{t("currentVehicleMileage")}</label>
                <input
                  type="number"
                  placeholder={t("mileagePlaceholder")}
                  value={mile}
                  onChange={handleMileageChange}
                />
                {mileError && (
                  <Message size="mini" negative>
                    {mileError}
                  </Message>
                )}
              </FormField>
            </Form>
            <div className="vin-info">
              <label>{t("vinInfoList")}</label>
              <List bulleted>
                <ListItem>{t("vinInfoListItem2")}</ListItem>
                <ListItem>{t("vinInfoListItem3")}</ListItem>
                <ListItem>{t("vinInfoListItem4")}</ListItem>
                <ListItem>{t("vinInfoListItem1")}</ListItem>
              </List>

              <Image src={VinInfo} />
              <Header as="h4">
                <Icon name="lock" /> {t("privacy")}
              </Header>
              <p>{t("keepYourVinSecure")}</p>
            </div>
          </div>
          <div>
            <Button
              fluid
              loading={isSubmitting}
              onClick={handleVinSubmit}
              disabled={!(vin.length == 17 && mile.length && !mileError) || isSubmitting}
              className="primary-button"
            >
              {isEbay() ? t("findMyVehicle") : t("addMyVehicle")}
            </Button>
          </div>
        </TabPane>
      )
    }
  ]

  const openCanadianFlow = () => {
    trackFirebaseAnalytics({
      event: gaJSON.EtoB_click_canadian_user_flow
    })
  }
  return showVehicle ? (
    <VehicleInfo
      handleSearchAgain={handleSearchAgain}
      asModal={asModal}
      closeModalHandler={closeModalHandler}
      serviceRequest={serviceRequest}
    />
  ) : showAddManualVehicle ? (
    <AddVehicleManual
      history={history}
      asModal={asModal}
      closeModalHandler={closeModalHandler}
      handleSearchAgain={handleSearchAgain}
    />
  ) : (
    <Card className="add-vehicle-card" raised={true}>
      <div>
        {false && (
          <Card fluid className="add-vehicle-tile" onClick={openCanadianFlow}>
            <Image src={CanadianFlag} /> {t("canadianResident")}
            <Icon name="right arrow" />
          </Card>
        )}
        {isCanada(user.country) ? (
          panes[1].render()
        ) : (
          <Tab
            activeIndex={activeIndex}
            onTabChange={handleTabChange}
            menu={{ secondary: true }}
            panes={panes}
          />
        )}
      </div>
    </Card>
  )
}

function mapStateToProps(state, props) {
  let user = state.user || {}
  let vehicle = state.selectedVehicle.selectedVehicle || {}
  let activeVehicle = (user.vehicles || []).find((v) => v.id === user.activeVehicleId) || {}

  return {
    user: user,
    vehicle: vehicle,
    activeVehicle: activeVehicle
  }
}

export default withRouter(connect(mapStateToProps)(withTranslation("vehicleDetails")(NewVehicle)))
